import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import api from '../../api/axios';
import BaseModal from '../utils/BaseModal';
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/lottie/loading.json";

type Props = {
    open: boolean;
    assetId?: string;
    onClose: () => void;
};

const Item3DViewerModal: React.FC<Props> = ({open, assetId, onClose}) => {
    const [loading, setLoading] = useState(false);
    const [viewerUrl, setViewerUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!open || !assetId) {
            setViewerUrl(null);
            return;
        }

        let cancelled = false;
        setLoading(true);

        api
            .get<{ url: string }>(`/item/${assetId}/3d-viewer`)
            .then((res) => {
                if (!cancelled) {
                    setViewerUrl(res.data.url);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    toast.error('Failed to load 360° 3D viewer');
                    onClose();
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [open, assetId]);

    let content;
    if (loading) {
        content = (
            <div
                className="w-full min-h-[300px] max-h-[82vh] rounded-lg items-center justify-center p-1 bg-neutral-800">
                <Lottie animationData={loadingAnimation} loop className="w-82"/>
            </div>
        );
    } else if (viewerUrl) {
        content = (
            <div className="w-full overflow-hidden rounded-lg bg-neutral-900">
                <iframe
                    src={viewerUrl}
                    title="CS2 3D Viewer"
                    width="100%"
                    height="600"
                    frameBorder="0"
                    allowFullScreen
                    className="w-full h-[500px] md:h-[600px] border-0"
                />
            </div>
        );
    }

    return (
        <BaseModal open={open} onAbort={onClose} maxWidth="lg">
            <div className="w-full min-h-[300px] max-h-[82vh] flex items-center justify-center p-1">
                {content}
            </div>
        </BaseModal>
    );
};

export default Item3DViewerModal;